export enum UserFlowTypes {
  ZIMPLER_FLOW = "zimplerflow",
  NORMAL_FLOW = "normalflow",
}
